"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var ProfileActions_1 = __importDefault(require("containersRechargly/Navbar/ProfileActions"));
var CompanyInfo_1 = __importDefault(require("./CompanyInfo"));
var CompanySelect_1 = __importDefault(require("./CompanySelect"));
var ProfileActions_2 = __importDefault(require("./ProfileActions"));
var MenuWrapper_1 = __importDefault(require("./styles/MenuWrapper"));
var ToolbarWrapper_1 = __importDefault(require("./styles/ToolbarWrapper"));
var NavBar = function (_a) {
    var isAdmin = _a.isAdmin;
    var _b = __read(react_1.default.useState(null), 2), anchorEl = _b[0], setAnchorEl = _b[1];
    var divRef = react_1.default.useRef(null);
    var handleClick = function () { return setAnchorEl(anchorEl ? null : divRef.current); };
    return ((0, jsx_runtime_1.jsx)(MenuWrapper_1.default, { children: (0, jsx_runtime_1.jsxs)(ToolbarWrapper_1.default, { children: [(0, jsx_runtime_1.jsx)(CompanyInfo_1.default, {}), isAdmin && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, { ref: divRef, component: "span", mt: -7 }), (0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ color: "neutral", size: "small", onClick: handleClick, className: "showOnHover" }, { children: "Switch company" })), anchorEl && (0, jsx_runtime_1.jsx)(CompanySelect_1.default, { anchorEl: anchorEl, setAnchorEl: setAnchorEl })] })), (0, jsx_runtime_1.jsx)(material_1.Box, { flexGrow: 1 }), end2end_1.IS_RECHARGLY ? (0, jsx_runtime_1.jsx)(ProfileActions_1.default, {}) : (0, jsx_runtime_1.jsx)(ProfileActions_2.default, {})] }) }));
};
exports.default = react_1.default.memo(NavBar);
